import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { Footer } from '../../../../containers';
import { Navbar } from '../../../../components';
import './B-Lykeiou.css';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import OEFE from '../../../../assets/OEFE.jpg';
import labora from '../../../../assets/labora.jpg';
import edu4schools from '../../../../assets/edu4schools.png';
import ypourgeio from '../../../../assets/ypourgeio.jpg';




const BLykeiou = () => {
  
    const form = useRef();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
  
    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs.sendForm('service_ald9cce', 'template_optgjil', form.current, 'EVgIFCLIjxstCs_IK')
        .then((result) => {
            console.log(result.text);
            console.log("message sent");
            e.target.reset();
            setShowSuccess(true);
            setShowError(false);
        }, (error) => {
            console.log(error.text);
            setShowSuccess(false);
            setShowError(true);
        });
    };
  
    const closePopup = () => {
      setShowSuccess(false);
      setShowError(false);
    };
  
  return (
    <div className="BLykeiou">
        <div className="gradient__bg">
          <Navbar />
        </div>
        <div className="BLykeiou__main-container">
          <div className="BLykeiou__container">
            <div className="BLykeiou__container-h">
              <h1>Β’ ΛΥΚΕΙΟΥ</h1>
              <div className="BLykeiou__container-p">
                <p>Ο μαθητής της Β’ Λυκείου παρακολουθεί μαθήματα σύμφωνα με το πρόγραμμα σπουδών που προτίθεται να επιλέξει στην Γ’ Λυκείου. Συγκεκριμένα, το πρόγραμμα σπουδών που ενδείκνυται να ακολουθήσει καλύπτει τόσο τις ανάγκες για τα μαθήματα της Β’ Λυκείου όσο και τις βάσεις που απαιτούνται για την Γ’ τάξη.</p>
                <p> Ωστόσο, του δίνεται η δυνατότητα του Επαγγελματικού προσανατολισμού, σε περίπτωση που δεν έχει επιλέξει έγκαιρα την κατεύθυνσή του, μια παροχή που θα τον οδηγήσει πιο κοντά στον στόχο του.</p>
              </div>
              <div className="BLykeiou__container-h">
                <h2>Ωρολόγιο πρόγραμμα Β΄ Λυκείου:</h2>
              </div>
              <div className="BLykeiou__container-table">
              <table>
                  <thead>
                    <tr>
                      <th colSpan="3">ΜΑΘΗΜΑΤΑ ΓΕΝΙΚΗΣ ΠΑΙΔΕΙΑΣ</th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr>
                        <td>ΑΛΓΕΒΡΑ - ΓΕΩΜΕΤΡΙΑ</td>
                        <td>3 ώρες/ εβδομάδα</td>
                      </tr>
                      <tr>
                        <td>ΧΗΜΕΙΑ ΓΕΝΙΚΗΣ</td>
                        <td>1 ώρα/ εβδομάδα</td>
                      </tr>
                      <tr>
                        <td>ΦΥΣΙΚΗ ΓΕΝΙΚΗΣ</td>
                        <td>1 ώρα/ εβδομάδα</td>
                      </tr>
                      <tr>
                        <td>ΕΚΘΕΣΗ - ΛΟΓΟΤΕΧΝΙΑ</td>
                        <td>2 ώρες/ εβδομάδα</td>
                      </tr>
                      <tr>
                        <td>ΒΙΟΛΟΓΙΑ</td>
                        <td>1 ώρα/ εβδομάδα</td>
                      </tr>
                  </tbody>
                </table>
              </div>
              <div className="BLykeiou__container-h">
                <h2>ΕΠΙΠΛΕΟΝ, ΜΑΘΗΜΑΤΑ ΑΝΑ ΕΠΙΣΤΗΜΟΝΙΚΟ ΠΕΔΙΟ</h2>
              </div>
              <div className="BLykeiou__container-table">
              <table>
                  <thead>
                    <tr>
                      <th colSpan="2" class="right-border">1. ΑΝΘΡΩΠΙΣΤΙΚΩΝ ΣΠΟΥΔΩΝ</th>
                      <th colSpan="2">2. ΘΕΤΙΚΩΝ ΣΠΟΥΔΩΝ</th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr>
                        <td>ΑΡΧΑΙΑ</td>
                        <td class="right-border">4 ώρες/ εβδομάδα</td>
                        <td>ΜΑΘΗΜΑΤΙΚΑ ΠΡΟΣΑΝΑΤΟΛΙΣΜΟΥ</td>
                        <td>2 ώρες/ εβδομάδα</td>
                      </tr>
                      <tr>
                        <td>ΛΑΤΙΝΙΚΑ</td>
                        <td class="right-border">1 ώρα/ εβδομάδα</td>
                        <td>ΦΥΣΙΚΗ ΠΡΟΣΑΝΑΤΟΛΙΣΜΟΥ</td>
                        <td>2 ώρες/ εβδομάδα</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td class="right-border"></td>
                        <td>ΧΗΜΕΙΑ Γ' ΛΥΚΕΙΟΥ</td>
                        <td>1 ώρα/ εβδομάδα</td>
                      </tr>
                  </tbody>
                </table>
              </div>
              <div className="BLykeiou__container-h">
                <h2>ΠΡΟΕΤΟΙΜΑΣΙΑ ΠΑΝΕΛΛΗΝΙΩΝ</h2>
              </div>
              <div className="BLykeiou__container-p">
                <p>Ο μαθητής της Β’ Λυκείου παρακολουθεί μαθήματα σύμφωνα με το πρόγραμμα σπουδών που προτίθεται να επιλέξει στην Γ’ Λυκείου. </p>
                <p>Στους μήνες Φεβρουάριο- Μάιο, ο μαθητής της Β Λυκείου προετοιμάζεται παράλληλα για τις πανελλαδικές που θα εξετασθεί την επόμενη χρονιά.</p>
                <p>Έτσι, τον Φεβρουάριο του διδακτικού έτους της Β Λυκείου εντάσσονται τα εξής μαθήματα:</p>
              </div>
              <div className="BLykeiou__container-table">
              <table>
                  <thead>
                    <tr>
                      <th colSpan="2" class="right-border">1. ΑΝΘΡΩΠΙΣΤΙΚΩΝ ΣΠΟΥΔΩΝ</th>
                      <th colSpan="2">2. ΘΕΤΙΚΩΝ ΣΠΟΥΔΩΝ</th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr>
                        <td>ΙΣΤΟΡΙΑ Γ' ΓΕΛ</td>
                        <td class="right-border">1 ώρα/ εβδομάδα</td>
                        <td>ΒΙΟΛΟΓΙΑ Γ΄ ΓΕΛ</td>
                        <td>2 ώρες/ εβδομάδα</td>
                      </tr>
                      <tr>
                        <td>ΛΑΤΙΝΙΚΑ Γ' ΓΕΛ</td>
                        <td class="right-border">1 ώρα/ εβδομάδα</td>
                        <td>ΜΑΘΗΜΑΤΙΚΑ ΠΡΟΣΑΝΑΤΟΛΙΣΜΟΥ</td>
                        <td>2 ώρες/ εβδομάδα</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td class="right-border"></td>
                        <td>ΟΙΚΟΝΟΜΙΑ Γ’ ΓΕΛ</td>
                        <td>1 ώρα/ εβδομάδα</td>
                      </tr>
                  </tbody>
                </table>
              </div>
              <div className="BLykeiou__container-h">
                <h2>ΤΟ ΘΕΡΙΝΟ ΠΡΟΓΡΑΜΜΑ ΠΡΟΕΤΟΙΜΑΣΙΑΣ ΠΕΡΙΛΑΜΒΑΝΕΙ:</h2>
              </div>
              <div className="BLykeiou__container-p">
                <p>Μαθήματα διάρκειας 6 εβδομάδων.</p>
                <p>Οι 4 πρώτες εβδομάδες ξεκινούν στις 14 Ιουνίου και ολοκληρώνονται στις 18 Ιουλίου.</p>
                <p>Η 5η και η 6η εβδομάδα των θερινών μαθημάτων πραγματοποιούνται από 18 έως 31 Αυγούστου.</p>
                <p>ΠΑΤΗΣΤΕ <a href="/Mathimata/Proetimasia" style={{ color: '#05B2DC', textDecoration: 'underline' }}>ΕΔΩ</a> ΓΙΑ ΤΟ ΘΕΡΙΝΟ ΠΡΟΓΡΑΜΜΑ ΠΡΟΕΤΟΙΜΑΣΙΑΣ</p>
              </div>
              <div className="BLykeiou__container-h">
                <h2>ΠΡΟΤΑΣΗ «ΑΝΟΔΟΥ» ΓΙΑ ΠΡΟΕΤΟΙΜΑΣΙΑ ΠΑΝΕΛΛΗΝΙΩΝ</h2>
              </div>
              <div className="BLykeiou__container-p">
                <p>Οι προτάσεις μας, σε περίπτωση που ο μαθητής της Β’ Λυκείου είναι κατασταλαγμένος για το επιστημονικό πεδίο που θα επιλέξει στην Γ’ Λυκείου είναι οι παρακάτω:</p>
              </div>
            </div>
            <div className="container">
              <div className="header">ΟΜΑΔΑ Α</div>
              <div className="content">
                <div className="box red">Ανθρωπιστικών <br /> Σπουδών Β’ Λυκείου</div>
                <div className="box darkblue">
                  <div>ΑΛΓΕΒΡΑ ΓΕΝΙΚΗΣ ΠΑΙΔΕΙΑΣ</div>
                  <div>ΕΚΘΕΣΗ – ΛΟΓΟΤΕΧΝΙΑ ΓΕΝΙΚΗΣ ΠΑΙΔΕΙΑΣ</div>
                  <div>ΑΡΧΑΙΑ ΠΡΟΣΑΝΑΤΟΛΙΣΜΟΥ</div>
                  <div>ΛΑΤΙΝΙΚΑ ΠΡΟΣΑΝΑΤΟΛΙΣΜΟΥ</div>
                </div>
                <div className="box blue"><a href="/Mathimata/G-Lykeiou?scrollTo=Anthropistikwn" style={{ color: '#05B2DC', textDecoration: 'underline' }}>Ανθρωπιστικών <br /> Σπουδών Γ’ Λυκείου</a></div>
              </div>
              <div className="header">ΟΜΑΔΑ Β</div>
              <div className="content">
                <div className="box red">Θετικών<br /> Σπουδών Β’ Λυκείου</div>
                <div className="box darkblue">
                  <div>ΑΛΓΕΒΡΑ ΓΕΝΙΚΗΣ ΠΑΙΔΕΙΑΣ</div>
                  <div>ΕΚΘΕΣΗ – ΛΟΓΟΤΕΧΝΙΑ ΓΕΝΙΚΗΣ ΠΑΙΔΕΙΑΣ</div>
                  <div>ΜΑΘΗΜΑΤΙΚΑ ΠΡΟΣΑΝΑΤΟΛΙΣΜΟΥ</div>
                  <div>ΦΥΣΙΚΗ ΠΡΟΣΑΝΑΤΟΛΙΣΜΟΥ</div>
                  <div>ΦΥΣΙΚΗ- ΧΗΜΕΙΑ ΓΕΝΙΚΗΣ ΠΑΙΔΕΙΑΣ</div>
                </div>
                <div className="box blue"><a href="/Mathimata/G-Lykeiou?scrollTo=thetikwn" style={{ color: '#05B2DC', textDecoration: 'underline' }}>Θετικών <br /> Σπουδών Γ’ Λυκείου</a></div>
              </div>
              <div className="header">ΟΜΑΔΑ Γ</div>
              <div className="content">
                <div className="box red">Θετικών<br /> Σπουδών Β’ Λυκείου</div>
                <div className="box darkblue">
                  <div>ΑΛΓΕΒΡΑ ΓΕΝΙΚΗΣ ΠΑΙΔΕΙΑΣ</div>
                  <div>ΕΚΘΕΣΗ – ΛΟΓΟΤΕΧΝΙΑ ΓΕΝΙΚΗΣ ΠΑΙΔΕΙΑΣ</div>
                  <div>ΒΙΟΛΟΓΙΑ</div>
                  <div>ΦΥΣΙΚΗ ΠΡΟΣΑΝΑΤΟΛΙΣΜΟΥ</div>
                  <div>ΦΥΣΙΚΗ- ΧΗΜΕΙΑ ΓΕΝΙΚΗΣ ΠΑΙΔΕΙΑΣ</div>
                </div>
                <div className="box blue"><a href="/Mathimata/G-Lykeiou?scrollTo=Ygeias" style={{ color: '#05B2DC', textDecoration: 'underline' }}>Σπουδών <br /> Υγείας Γ’ Λυκείου</a></div>
              </div>
              <div className="header">ΟΜΑΔΑ Δ</div>
              <div className="content">
                <div className="box red">Θετικών<br /> Σπουδών Β’ Λυκείου</div>
                <div className="box darkblue">
                  <div>ΑΛΓΕΒΡΑ ΓΕΝΙΚΗΣ ΠΑΙΔΕΙΑΣ</div>
                  <div>ΕΚΘΕΣΗ – ΛΟΓΟΤΕΧΝΙΑ ΓΕΝΙΚΗΣ ΠΑΙΔΕΙΑΣ</div>
                  <div>ΜΑΘΗΜΑΤΙΚΑ ΠΡΟΣΑΝΑΤΟΛΙΣΜΟΥ</div>
                </div>
                <div className="box blue"><a href="/Mathimata/G-Lykeiou?scrollTo=oikonomias" style={{ color: '#05B2DC', textDecoration: 'underline' }}>Σπουδών Οικονομίας &<br />Πληροφορικής Γ’ Λυκείου</a></div>
              </div>
              <div className="header">ΟΜΑΔΑ Ε</div>
              <div className="BLykeiou__container-p">
                <h3>ΟΜΑΔΑ ΟΛΟΚΛΗΡΩΜΕΝΗΣ ΚΑΛΥΨΗΣ ΔΙΔΑΚΤΕΑΣ ΥΛΗΣ:</h3>
                <p>Περιλαμβάνει όλα τα παραπάνω μαθήματα ανάλογα με το πρόγραμμα σπουδών που ακολουθεί ο μαθητής στο επιστημονικό πεδίο που ανήκει.</p>
              </div>
            </div>
          </div>
          <div className="BLykeiou__side-Containers">
              <div className="BLykeiou__side-Container1">
                <h1>Χρήσιμες Σελίδες</h1>
                <Accordion allowZeroExpanded allowMultipleExpanded preExpanded={['a']}>
                  <AccordionItem uuid="a">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        Σημεία Υπεροχής
                      </AccordionItemButton>
                    </AccordionItemHeading>
                      <AccordionItemPanel>
                        <p>
                        Το φροντιστήριο φημίζεται ως  το πιο οργανωμένο και φιλικό προς τους μαθητές του εκπαιδευτήριο. Σε συνδυασμό με την άψογη συνεργασία των καθηγητών του το καθιστά ένα από τα καλύτερα της περιοχής μας.
                        </p>
                        <a href="/Frontistirio/Paroxes-Ypiresiwn/" target="_blank" rel="noopener noreferrer">
                          <button class="custom-btn btn-5">Λεπτομέρειες</button>
                        </a>
                        </AccordionItemPanel>
                  </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                        "Ομάδα ή Μονάδα" ;
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Το παιδί και ο έφηβος μαθαίνουν καλύτερα το «τι» και το «πως» μαζί με τους άλλους. “Learning together, learning to live together”  -UNESCO- 
                          </p>
                          <a href="/OmadaMonada" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                        Πρόταση "ΑΝΟΔΟΥ" για Πανελλήνιες
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Οι υπεύθυνοι σπουδών του  φροντιστηρίου μας, μετά από τόσα χρόνια εμπειρίας είναι ικανοί  να προτείνουν την καλύτερη πρόταση ώστε να επιτύχει ο μαθητής  τον στόχο του.
                          </p>
                          <a href="/Mathimata/B-Lykeiou" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          Σχόλια Μαθητών
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Οι απόψεις των μαθητών μας για την λειτουργία του φροντιστηρίου αποτελούν κίνητρο για σκληρή και απαιτητική δουλειά, ωστόσο τα θετικά σχόλια είναι η ανταπόδοση όλων των προσπαθειών των καθηγητών μας . 
                          </p>
                          <a href="/PoioiEimaste/Oi-Mathites-Mas/" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                </Accordion>
              </div>
              <div className="anodos__blykeiou-email-container">
              <form className="anodos__blykeiou-email-container_form" ref={form} onSubmit={sendEmail}>
                <h1 className="anodos__blykeiou-email-container_h1">Φόρμα Επικοινωνίας</h1>
                <label className="anodos__blykeiou-email-container_label">Όνομα</label>
                <input className="anodos__blykeiou-email-container_input" type="text" name="user_name" required/>
                <label className="anodos__blykeiou-email-container_label">Email</label>
                <input className="anodos__blykeiou-email-container_input" type="email" name="user_email" required/>
                <label className="anodos__blykeiou-email-container_label">Μήνυμα</label>
                <textarea className="anodos__blykeiou-email-container_input-message" name="message" required/>
                <input className="anodos__blykeiou-email-container_btn" type="submit" value="Αποστολή" />
              </form>

              {showSuccess && (
                <div className="anodos__blykeiou-email-container_popup anodos__blykeiou-email-container_popup--success">
                  <span>Your message was sent successfully!</span>
                  <button className="anodos__blykeiou-email-container_close" onClick={closePopup}>X</button>
                </div>
              )}

              {showError && (
                <div className="anodos__blykeiou-email-container_popup anodos__blykeiou-email-container_popup--error">
                  <span>There was an error sending your message. Please try again later.</span>
                  <button className="anodos__blykeiou-email-container_close" onClick={closePopup}>X</button>
                </div>
              )}
              </div>
            <div className="anodos__Alukeiou-links-container">
                <a href="https://www.oefe.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alukeiou-links-container_box" style={{ backgroundImage: `url(${OEFE})` }}></div>
                </a>
                <a href="https://labora.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alukeiou-links-container_box" style={{ backgroundImage: `url(${labora})` }}></div>
                </a>
                <a href="https://www.edu4schools.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alukeiou-links-container_box" style={{ backgroundImage: `url(${edu4schools})` }}></div>
                </a>
                <a href="https://www.minedu.gov.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alukeiou-links-container_box" style={{ backgroundImage: `url(${ypourgeio})` }}></div>
                </a>
            </div>
            </div>
        </div>
        <Footer />
    </div>
  )
}

export default BLykeiou